import React from 'react'
import { Skeleton } from '@progress/kendo-react-indicators'
import styles from 'components/Dashboard/index.module.scss'

const TaskItemSkelton = (index) => {
    return (
        <div key={index} className={`px-3 py-4 mb-3 ${styles["task-item"]}`}>
            <div className="d-flex align-items-center gap-2 mb-2">
                <Skeleton shape="text" style={{ width: "80px", height: "14px" }} />
                <Skeleton shape="text" style={{ width: "90px", height: "14px" }} />
                <Skeleton shape="text" style={{ width: "130px", height: "14px", marginLeft: "auto" }} />
            </div>
            <Skeleton shape="text" style={{ width: "60%", height: "14px" }} />
        </div>
    )
}

export default TaskItemSkelton